export default {
  getQuestionAndAnswerMemberList: "BackEnd/getQuestionAndAnswerMemberList",
  getQuestionAndAnswerMemberDetails:
    "BackEnd/getQuestionAndAnswerMemberDetails",
  getQuestionAndAnswerMemberStatus0:
    "BackEnd/getQuestionAndAnswerMemberStatus0",
  setQuestionAndAnswerMember: "BackEnd/setQuestionAndAnswerMember",
  updateQuestionAndAnswerMember: "BackEnd/updateQuestionAndAnswerMember",

  getMyQuestionAndAnswerMemberList: "BackEnd/getMyQuestionAndAnswerMemberList",
};
